// src/lib/firebaseConfig.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAZV3UtnWqbGaw5qWhUm_D-Mdyxqj0kvPA",
  authDomain: "radio-head-2020.firebaseapp.com",
  databaseURL: "https://radio-head-2020.firebaseio.com",
  projectId: "radio-head-2020",
  storageBucket: "radio-head-2020.appspot.com",
  messagingSenderId: "414671964081",
  appId: "1:414671964081:web:5ef6890f231c1913649f90"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
